import {useSelector} from 'react-redux';

export function useCurrentGateway() {
    const gatewayId = useSelector(state => state.settings.panel.id);
    return useSelector(state => state.control.gatewayList.find(g => g.id === gatewayId));
}
